var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 11C14.2093 11 16.0001 9.20914 16.0001 7C16.0001 4.79086 14.2093 3 12.0001 3C9.79097 3 8.00011 4.79086 8.00011 7C8.00011 9.20914 9.79097 11 12.0001 11ZM9.00008 15H15.0001C17.2092 15 19.0001 16.7909 19.0001 19C19.0001 20.1046 18.1046 21 17.0001 21H7.00008C5.89551 21 5.00008 20.1046 5.00008 19C5.00008 16.7909 6.79094 15 9.00008 15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80578 6.99998C8.80578 5.23583 10.2359 3.80569 12.0001 3.80569C13.7642 3.80569 15.1944 5.23583 15.1944 6.99998C15.1944 8.76414 13.7642 10.1943 12.0001 10.1943C10.2359 10.1943 8.80578 8.76414 8.80578 6.99998ZM12.0001 2.19427C9.34595 2.19427 7.19436 4.34586 7.19436 6.99998C7.19436 9.6541 9.34595 11.8057 12.0001 11.8057C14.6542 11.8057 16.8058 9.6541 16.8058 6.99998C16.8058 4.34586 14.6542 2.19427 12.0001 2.19427ZM5.80574 19C5.80574 17.2358 7.23587 15.8057 9.00003 15.8057H15C16.7642 15.8057 18.1943 17.2358 18.1943 19C18.1943 19.6596 17.6596 20.1943 17 20.1943H7.00003C6.34044 20.1943 5.80574 19.6596 5.80574 19ZM9.00003 14.1943C6.34591 14.1943 4.19432 16.3459 4.19432 19C4.19432 20.5496 5.45048 21.8057 7.00003 21.8057H17C18.5496 21.8057 19.8057 20.5496 19.8057 19C19.8057 16.3459 17.6542 14.1943 15 14.1943H9.00003Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default "/Frontend/static/media/profile.acbfdcb463b0b2e63e4671be3f8e33f7.svg";
export { ForwardRef as ReactComponent };